<template>
  <v-row>
    <v-col lg="12">
      <v-navigation-drawer permanent floating style="width: 100%" id="menu-sheet">
        <v-list dense nav>
          <router-link
            v-for="item in items"
            :key="item.title"
            :to="{name: item.routeName}"
            style="text-decoration: none"
          >
            <v-list-item
              link
              :class="{'active-menu': item.routeName == activeTab}"
              @click="activeTab = item.routeName"
            >
              <v-row class="pl-5" style="z-index: 9999;">
                <v-col lg="12" class="pb-1 pt-1">
                  <v-list-item-icon>
                    <v-icon
                      size="23"
                      class="menu-icons"
                      :class="{'active-icon': item.routeName == activeTab}"
                    >{{item.icon}}</v-icon>
                    <v-list-item-content class="pl-5">
                      <v-list-item-title class="menu-title-container">
                        <span
                          class="menu-item-title"
                          :class="{'active-text': item.routeName == activeTab}"
                        >{{ $t(item.title) }}</span>
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item-icon>
                </v-col>
              </v-row>
            </v-list-item>
          </router-link>
        </v-list>

        <v-divider class="menu-divider my-3"></v-divider>

        <v-list-item>
          <v-list-item-content class="pb-0">
            <v-list-item-title class="ml-3">
              <p class="menu-heading pt-2 mb-4">Use ISM Project as</p>
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list dense nav>
          <v-list-item
            link
            v-for="role in arrangedRoles"
            :key="role"
            @click="onSwitchAccount(role)"
          >
            <v-row class="pl-5">
              <v-col lg="12" class="pb-1 pt-1">
                <v-list-item-content>
                  <v-list-item-title>
                    <span
                      class="menu-item-title role-item"
                      :class="{'active-role': role.toLowerCase() == activeRole}"
                    >{{ role }}</span>
                    <span class="dot mr-5 primary-color" v-if="$store.state.role == role"></span>
                  </v-list-item-title>
                </v-list-item-content>
              </v-col>
            </v-row>
          </v-list-item>
        </v-list>
      </v-navigation-drawer>
    </v-col>
  </v-row>
</template>

<script>
export default {
  mounted: function () {
    this.getUsers();

    if (this.$store.state.role == "centre") {
      this.items = this.items.filter((item) => {
        return item.routeName != "Centres";
      });
    }
  },
  data() {
    return {
      activeTab: "Dashboard",
      activeRole: this.$store.state.role,
      drawer: true,
      group: null,
      items: [
        {
          title: "menu.dashboard",
          icon: "mdi-view-dashboard-outline",
          routeName: "Dashboard",
        },
        {
          title: "menu.centre",
          icon: "mdi-home-city-outline",
          routeName: "Centres",
        },
        {
          title: "menu.learner",
          icon: "mdi-account-group-outline",
          routeName: "Learners",
        },
        {
          title: "menu.unit",
          icon: "mdi-book-outline",
          routeName: "Units",
        },
        {
          title: "menu.qualification",
          icon: "mdi-school-outline",
          routeName: "Qualifications",
        },
         {
          title: "Courses",
          icon: "mdi-school-outline",
          routeName: "Courses",
        },
        {
          title: "menu.certification",
          icon: "mdi-certificate-outline",
          routeName: "Certifications",
        },
        {
          title: "menu.admin",
          icon: "mdi-account-circle-outline",
          routeName: "Admins",
        },
        {
          title: "Documents",
          icon: "mdi-file-document-outline",
          routeName: "Documents",
        },
      ],
      roles: [],
    };
  },
  computed: {
    arrangedRoles: function () {
      // rearrange the roles to show from highest to lowest on menu
      const arrangedRoles = [];

      for (let i = 0; i < this.roles.length; i++) {
        if (this.roles[i] == "master") {
          arrangedRoles.unshift(this.roles[i]);
        } else if (this.roles[i] == "learner") {
          arrangedRoles.push(this.roles[i].toLowerCase());
        } else if (this.roles[i] == "ao") {
          let masterFound = false;

          for (let j = 0; j < arrangedRoles.length; j++) {
            if (arrangedRoles[j] == "master") {
              arrangedRoles.splice(j + 1, 0, this.roles[i]);
              masterFound = true;
              break;
            }
          }

          if (!masterFound) {
            arrangedRoles.unshift(this.roles[i]);
          }
        } else if (this.roles[i] == "centre") {
          let learnerFound = false;

          for (let j = 0; j < arrangedRoles.length; j++) {
            if (arrangedRoles[j] == "learner") {
              arrangedRoles.splice(j - 1, 0, this.roles[i].toLowerCase());
              learnerFound = true;
              break;
            }
          }

          if (!learnerFound) {
            arrangedRoles.push(this.roles[i].toLowerCase());
          }
        }
      }

      return arrangedRoles;
    },
  },
  watch: {
    activeTab: function (newValue) {
      this.activeTab = newValue;
    },
    activeRole: function (newValue) {
      this.activeRole = newValue;
    },
  },
  methods: {
    getUsers: function () {
      fetch(
        `${process.env.VUE_APP_ROOT_API}/users/roles?email=${this.$store.state.email}`,
        {
          headers: {
            Authorization: `Bearer ${this.$store.state.jwt}`,
          },
        }
      )
        .then((response) => response.json())
        .then((data) => {
          this.roles = data.roles;
        })
        .catch((error) => {
          console.error(error);
        });
    },
    onSwitchAccount: function (role) {
      fetch(`${process.env.VUE_APP_ROOT_API}/auth/account`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.$store.state.jwt}`,
        },
        body: JSON.stringify({ email: this.$store.state.email, role }),
      })
        .then((response) => response.json())
        .then((data) => {
          this.$store.commit("updateJwt", data.token);
          this.$store.commit("updateEmail", data.email);
          this.$store.commit("updateRole", data.role);
          this.$store.commit("updateUserId", data.userId);

          this.$router.push({ name: "Dashboard" });
        })
        .catch((error) => {
          console.error(error);
        });
    },
  },
};
</script>

<style scoped>
#menu-sheet {
  width: 16.5vw !important;
}

.menu-heading {
  font-size: 0.85rem;
  font-weight: 600;
  text-transform: uppercase;
}

.menu-item-title {
  font-size: 0.875rem;
  font-weight: 400;
  letter-spacing: 0.01em;
  color: #172b4d;
}

.role-item {
  text-transform: capitalize;
}

.dot {
  float: right;
  height: 7px;
  width: 7px;
  border-radius: 50%;
  display: inline-block;
  margin-top: 0.3rem;
}

.menu-divider {
  width: 90%;
  margin: 0 auto;
}

.active-menu {
  background-color: #b3d4fc44;
  border-radius: 0;
}

.active-icon {
  color: #6490f1;
}

.active-text {
  font-weight: 700;
}

.menu-title-container {
  margin-bottom: 0.18rem;
}

.menu-icons {
  padding-bottom: 2.6%;
}

.active-role {
  color: #6490f1 !important;
  font-weight: bold;
}
</style>